export const emailRegex = /^(([^!#$%&'*+-/=?^_`{|}~<>()[\]\\.,;:\s@"][^<>()[\]\\.,;:\s@"]*(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const moneyRegex = /^((0\.(0[1-9]|[1-9]\d?))|([1-9]\d*(\.\d{1,2})?))$/
